import 'jspdf-autotable';
import {
  generateExcel,
  HEADER_COLOR,
  launchAlert,
  MAX_DAILY_HOURS,
  MAX_EXTRA_HOURS,
  MAX_WEEK_HOURS,
} from './mixin-export';
import alert from 'sweetalert2';
import axios from 'axios';
import i18n from 'src/i18n';
import jsPDF from 'jspdf';
import SweetAlert from 'src/class/Alerts';

const mixinExportReport = {
  methods: {
    exportToSAP() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );
      let response = axios({
        url: '/auth/works/laborheaders/sap',
        method: 'POST',
        data: { ...this.getDataToExport },
        responseType: 'blob',
      });
      const date = new Date().toISOString().split('T')[0];
      return response.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${i18n.t('labor.sap_activity_report')}_${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        alert.close();
      });
    },
    
    exportToSM() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );
      let response = axios({
        url: '/auth/works/activitysheets/sm/excel',
        method: 'POST',
        data: { ...this.getDataToExport },
        responseType: 'blob',
      });
      const date = new Date().toISOString().split('T')[0];
      return response.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${i18n.t('labor.soft_manager_report')}_${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        alert.close();
      });
    },

    exportToASP() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      const date = new Date().toISOString().split('T')[0];

      return axios({
        url: '/auth/works/activitysheets/asp/csv',
        method: 'POST',
        data: { ...this.getDataToExport },
        responseType: 'blob',
      }).then((response) => {
        const contentType = response.headers['content-type'] || '';
        const isZip = contentType.includes('application/zip');

        const extension = isZip ? 'zip' : 'csv';
        const mimeType = isZip ? 'application/zip' : 'text/csv;charset=utf-8';

        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${i18n.t('labor.sp_report')}_${date}.${extension}`
        );

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
        alert.close();
      });
    },

    async exportXLSHeader() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data, headers } = await this.generateHeadersAndData();
        const date = new Date().toISOString().split('T')[0];
        await generateExcel(
          true,
          `${i18n.t('common_words.activity_report')}_${date}`,
          headers,
          data,
          7
        );
      }, 1000);
    },

    async exportToPDFHeader() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data } = await this.generateHeadersAndData();

        const columns = [
          { header: i18n.t('common_words.date'), dataKey: '0' },
          { header: i18n.t('common_words.code'), dataKey: '1' },
          { header: i18n.t('labor.worker'), dataKey: '2' },
          { header: i18n.t('common_words.farm'), dataKey: '3' },
          { header: i18n.t('common_words.status'), dataKey: '4' },
          { header: i18n.t('common_words.typing_user'), dataKey: '5' },
          { header: i18n.t('common_words.observation'), dataKey: '6' },
        ];
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        });

        let body = [];
        body = data.map((row) => {
          const newRow = [...row];
          if (row[7]) {
            newRow.style = { fillColor: [253, 230, 228] };
          }
          row[7] = null;
          return newRow;
        });

        const headerStyle = {
          fillColor: HEADER_COLOR,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'left',
        };

        doc.autoTable({
          head: [columns.map((col) => col.header)],
          body: body,
          columns: columns,
          headStyles: headerStyle,
          didParseCell: function (data) {
            // Aplicar estilos personalizados si existen
            if (data.row.raw && data.row.raw.style) {
              data.cell.styles.fillColor = data.row.raw.style.fillColor;
            }
          },

          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          styles: { fontSize: 8 },
        });
        const date = new Date().toISOString().split('T')[0];
        doc.save(`${i18n.t('common_words.activity_report')}_${date}.pdf`);
        alert.close();
      }, 1000);
    },

    checkForErrors(row) {
      const { exceeds_daily_limit, extra_day_hours, is_duplicate, is_daily_hour_exceeds } = row;
      const isExtraWeekHouExceed = this.getExtraWeekHourExceedByWorker(row);
      return (
        is_daily_hour_exceeds == true ||
        (extra_day_hours && Number(extra_day_hours) > MAX_EXTRA_HOURS) ||
        isExtraWeekHouExceed == true
      );
    },

    generateHeadersAndData() {
      const data = this.tableData.map((header) => {
        const { date_save, worker, farm, signature, user_name, observations } =
          header;
        const error = this.checkForErrors(header);

        return [
          date_save,
          worker.code,
          `${worker.first_name} ${worker.last_name}`,
          farm.name,
          signature ? 'Firmado' : 'No Firmado',
          user_name,
          observations,
          error,
        ];
      });

      const headers = [
        i18n.t('common_words.date'),
        i18n.t('common_words.code'),
        i18n.t('labor.worker'),
        i18n.t('common_words.farm'),
        i18n.t('common_words.status'),
        i18n.t('common_words.typing_user'),
        i18n.t('common_words.observation'),
      ];

      return { headers, data };
    },
  },
};

export default mixinExportReport;
